<script>
import axios from 'axios'
import ClientRow from './ClientRow.vue'

export default {
  mounted: function () {
    this.$on('remove', this.removeClient);
    this.$nextTick(function () {
      this.fetchClients();
      this.interval = setInterval(this.fetchClients.bind(this), 3000);
    });
  },
  components: {
    'client-row': ClientRow
  },
  data: function () {
    return {
      clients: [],
      interval: null,
      clientsUrl: "/api/clients",
      sortReverse: false,
    };
  },
  destroyed: function () {
    if (typeof this.interval !== "undefined") {
      clearInterval(this.interval);
    }
  },
  methods: {
    fetchClients: function () {
      let self = this;
      axios.get(this.clientsUrl).then(function (response) {
        self.clients = response.data.result;
        self.sortClients();
      }).catch(function (err) {
        console.log(err);
      });
    },
    removeClient: function (clientId) {
      axios.delete(this.clientUrl).then(() => {
        self.clients.splice(this.clients.findIndex((client) => client.id === clientId), 1);
      });
    },
    sortClients: function () {
      let lessThan, greaterThan;
      if (!this.sortReverse) {
        lessThan = -1;
        greaterThan = 1;
      } else {
        lessThan = 1;
        greaterThan = -1;
      }
      this.clients.sort(function (c1, c2) {
        let c1UpperId = c1.id.toUpperCase();
        let c2UpperId = c2.id.toUpperCase();
        if (c1UpperId < c2UpperId) {
          return lessThan;
        }
        else if (c1UpperId > c2UpperId) {
          return greaterThan;
        }
        else {
          return 0; // This generally shouldn't happen
        }
      });
    },
    toggleSortOrder: function () {
      this.sortReverse = !this.sortReverse;
      this.sortClients();
    }
  },
  name: 'Clients',
}
</script>

<template>
  <table id="client-table" class="striped">
    <thead>
      <tr>
        <th>ID</th>
        <th>INI Version</th>
        <th>Pings</th>
        <th>Run Status Ping</th>
        <th>Blacklist</th>
        <th><a class="waves-effect waves-teal btn-floating" v-on:click="toggleSortOrder">
            <i class="material-icons right">sort_by_alpha</i>
        </a></th>
      </tr>
    </thead>
    <tbody>
      <client-row v-bind.sync="client" v-for="(client, idx) in clients" v-bind:key="idx"/>
    </tbody>
  </table>
</template>
